import Vue from 'vue'
import App from './App.vue'

import './styles/main.css';
import router from './router'

import {Button, 
        Select,
        Backtop,
        Icon,
        Image,
        Pagination,
        Carousel,
        CarouselItem,} from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';

Vue.use(Button)
Vue.use(Select)
Vue.use(Icon)
Vue.use(Image)
Vue.use(Backtop)
Vue.use(Pagination)
Vue.use(Carousel)
Vue.use(CarouselItem)

import TitleView from '../src/components/TitleView'
// 分页组件
import Paginations from "../src/components/Pagination";

// 全局组件挂载
Vue.component('TitleView', TitleView)
Vue.component('Pagination',Paginations)

// fade/zoom 等
import 'element-ui/lib/theme-chalk/base.css';
// collapse 展开折叠
import CollapseTransition from 'element-ui/lib/transitions/collapse-transition';

Vue.component(CollapseTransition.name, CollapseTransition)


import {handleNewsData,removeHtmlStyle,handleHtmlString,hightLightString} from '@/utils/index'
import { scrollTo } from '@/utils/scroll-to'

Vue.prototype.$handleNewsData = handleNewsData;
Vue.prototype.$removeHtmlStyle = removeHtmlStyle;
Vue.prototype.$handleHtmlString = handleHtmlString;
Vue.prototype.$scrollTo = scrollTo;
Vue.prototype.$hightLightString = hightLightString;

// 区人大官网链接
// 本地服
// Vue.prototype.$friendUrl = "http://192.168.1.32:1200/#/home";

// 测试服
// Vue.prototype.$friendUrl = "http://11.81.40.6:1200/#/home";

// 公网Ip
Vue.prototype.$friendUrl = (window.location.origin).replace('1100','1200');//"http://218.64.194.90:1200/#/home";


Vue.config.productionTip = false

new Vue({
  router,
  render: h => h(App),
}).$mount('#app')

